const styleOverrides = {
  row: {
    gap: '32px',
  },
};

export default styleOverrides;
